import { capitalizeFirstLetter } from 'shared/utils/capitalizeFirstLetter'
import { getBrowser, getSystemName } from 'shared/utils/getUserSystemData'

export const getUserBuild = () => {
  const { name, version } = getBrowser()

  return `Your current browser: ${capitalizeFirstLetter(name)} on ${getSystemName()} ${version}`
}
